import { Box, Flex, FormControl, Text } from '@chakra-ui/react'
import type { Offer, OfferLeasing } from 'BrokerTsLib/src/dtos'

import { useGetOfferCkp } from '../../hooks/useOffer'
import { InputGroup } from '../InputGroup'
import { Loading } from '../Loading'
import { HelperTooltip } from '../ui/HelperTooltip'
import { SliderLabel } from '../ui/SliderLabel'

export const QuoteItemCkp = ({ offer }: { offer: OfferLeasing | Offer }) => {
  const { isLoading: isLoadingCkp, data: dataCkp } = useGetOfferCkp(offer.offerId)
  const ckp = dataCkp?.data

  return (
    <Box as="form" sx={{ height: '100%' }}>
      {isLoadingCkp && <Loading large={true} />}

      {!isLoadingCkp && ckp &&
        <Flex direction={'column'} gap={4}>
          {(!ckp || !ckp.message && (ckp.ckpMonths ?? -1) < 0 && (ckp.ckpClaims ?? -1) < 0) &&
            <Text>Žádné informace z ČKP nejsou k dispozici</Text>
          }

          {!!ckp.message && <Text>{ckp.message}</Text>}

          {ckp && ckp.ckpMonths >= 0 &&
            <FormControl sx={{ gap: 2 }}>
              <SliderLabel
                label='Délka pojištění'
                value={<HelperTooltip label={`Celková doba pojištění ${ckp.ckpMonths}: měsíců`} />}
              />

              <InputGroup
                htmlSize={8}
                variant='outline'
                type='number'
                sx={{ fontSize: 'md', fontWeight: 'bold' }}
                value={ckp.ckpMonths}
                rightElement={<Box px={5}>měsíců</Box>}
                isDisabled
              />
            </FormControl>
          }

          {ckp && ckp.ckpMonths >= 0 &&
            <FormControl sx={{ gap: 2 }}>
              <SliderLabel
                label='Počet škod'
                value={<HelperTooltip label={`Počet pojistných událost: ${ckp.ckpClaims}`} />}
              />

              <InputGroup
                htmlSize={8}
                variant='outline'
                type='number'
                sx={{ fontSize: 'md', fontWeight: 'bold' }}
                value={ckp.ckpClaims}
                isDisabled
              />
            </FormControl>
          }
        </Flex>
      }
    </Box >
  )
}
